// extracted by mini-css-extract-plugin
export var container = "WidgetSuccessMessage-module--container--5fd52";